import { useEffect, useState } from "react";
import {
  GSForm,
  GSSidePanelPage,
  useFormDataValidation,
} from "golfstatus_react_components";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useMatch } from "react-router-dom";

//import scss
import "./guest-checkout-page.scss";
import {
  useNotificationAction,
  useNotificationBanner,
  useNotifications,
} from "../../../../hooks/notificationHooks";
import { getCustomerForm } from "../../../../forms/PackageForm";
import { useDispatch, useSelector } from "react-redux";
import {
  clearNotifications,
  saveCustomerThunk,
  selectRegistrationOrder,
} from "../../../../reducers/registrationOrderSlice";
import { getCurrentUser } from "../../../../app/gs-session";
import { useTournament } from "../../../../hooks/tournamentHooks";
import { FULFILLED } from "../../../../app/api";
import { getRouting } from "../../../../helpers/Converters";
import { eventBaseRoute, getProp, ORDER_ID, TOURNAMENT_ID } from "../../../../routes/event";
import { useGolfstatusNavigate } from "../../../../hooks/navigationHooks";

//Name the component
const GuestCheckoutPage = (props) => {
  const currentUser = getCurrentUser();

  const registrationOrder = useSelector(selectRegistrationOrder);
  const registrationCustomer = registrationOrder.registrationCustomer;

  const dispatch = useDispatch();

  const [tempCustomer, setTempCustomer] = useState({ ...registrationCustomer });
  const tournament = useTournament();

  const [context, isValid, setIsValid] = useFormDataValidation({
    initialValid: false,
    setData: (update) => {
      setTempCustomer(update);
    },
    data: tempCustomer,
  });

  const fallbackMatch = useMatch(
    getRouting(eventBaseRoute, [TOURNAMENT_ID, "cart", ORDER_ID, "*"])
  );
  const tournamentID = getProp(fallbackMatch?.params, TOURNAMENT_ID)
  const orderID = getProp(fallbackMatch?.params, ORDER_ID)

  const fallbackRoute = getRouting(eventBaseRoute, [
    tournamentID,
    "cart",
    orderID
  ]);
  const navigate = useGolfstatusNavigate(fallbackRoute);

  const notifications = useNotifications().filteredNotifications([
    "saveCustomerThunk",
  ]);

  useNotificationAction(
    FULFILLED,
    notifications,
    () => {
      leftNavigation();
    },
    "saveCustomerThunk"
  );

  useEffect(() => {
    return () => {
      dispatch(clearNotifications());
    };
  }, [dispatch]);

  const save = () => {
    setIsValid(false);
    dispatch(
      saveCustomerThunk({ ...tempCustomer, tournament, registrationOrder })
    );
  };

  const getDrawerActions = () => {
    let actions = [
      {
        name: "Save & Continue",
        isDisabled: !isValid,
        action: save,
        type: "black",
      },
      { name: "cancel", action: leftNavigation, type: "grey" },
    ];
    return actions;
  };

  const leftNavigation = () => {
    navigate(-1);
  };

  const getNavigation = () => {
    //Add Title to your component
    return {
      title: `Contact Details`,
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const getContactActions = () => {
    if (currentUser?.uid) {
      return [];
    }
    return [
      {
        title: "Sign In",
        type: "no-wrap grey",
        onClick: () => {
          window.location.href = process.env.REACT_APP_GOLFSTATUS_LOGIN_URL;
        },
      },
    ];
  };

  const getContent = () => {
    return (
      <GSForm
        formTitle="Contact Details"
        formActions={getContactActions()}
        formSections={getCustomerForm(context)}
      ></GSForm>
    );
  };

  const timeoutAction = () => {
    dispatch(clearNotifications());
  };

  const getDrawer = () => {
    return {
      actions: getDrawerActions(),
    };
  };

  const [banner] = useNotificationBanner({ notifications, timeoutAction });

  return (
    //name the component tag
    <guest-checkout-page>
      <GSSidePanelPage
        header={getNavigation()}
        banner={banner}
        content={getContent()}
        drawer={getDrawer()}
      ></GSSidePanelPage>
    </guest-checkout-page>
  );
};

//export the new namet
export default GuestCheckoutPage;
